import React, { Component } from 'react';
import {
    ARISTOCRATS,
    available_docks_for_guest,
    do_i_have_matching_amenity,
    do_i_have_matching_bed,
    do_i_have_matching_lodging
} from '../../Common/CardUtilities';
import { available_guest_orbits } from '../../Common/StationUtilities';

import '../../Controls/tradelane-selector.css';
import FireIcon from '../../Common/FireIcon';
import CheckmarkIcon from '../../Common/CheckmarkIcon';
import DockIcon from '../../Common/DockIcon';


export default class TheRiverIndicator extends Component {

    constructor(props) {
        super(props);
        this.state = {
            highlight: false,
            discard: false,
        };
    }

    // update due to gamePlayer update.

    highlight = () => {
        // consider.... dock must be available?
        this.setState({highlight: true});
    }
    showDiscard = () => {
        this.setState({discard: true});
    }

    clearIndicators = () => {
        this.setState({highlight: false, discard: false, free: false});
    }

    render() {
        const tradelaneData = this.props.tradelaneData;
        return <>
            {tradelaneData.matchingLodging && <CheckmarkIcon className={'tradelane-matching-lodging'}/>}
            {tradelaneData.matchingAmenity && <CheckmarkIcon className={'tradelane-matching-amenity'}/>}
            <div className={'tradelane-dock-payouts'}>
                {(tradelaneData.dockPayouts || []).map((points, dockIndex) => (
                    points > 0
                        ? <DockIcon key={dockIndex}
                                    dockIndex={dockIndex}
                                    value={points}
                                    className={'tradelane-dock-payout'}/>
                        : null
                ))}
            </div>
            {tradelaneData.willBurn && <FireIcon className={'tradelane-will-burn'}/>}
            {this.state.highlight && <div className={'tradelane-highlight'}/>}
            {this.state.discard && <div className={'tradelane-discard'}/>}
            {this.props.inFlight && <div className={'tradelane-in-flight'}/>}
        </>;
    }
}
